import { m } from 'framer-motion';
import { useState, useEffect } from 'react';
// @mui
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import axios from 'axios';
// components
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { varHover } from 'src/components/animate';
//
import NotificationItem from './notification-item';
import { useWebSocket } from '../notification-context';

// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const drawer = useBoolean();

  const router = useRouter();

  const { notifications, markNotificationAsRead } = useWebSocket();

  const smUp = useResponsive('up', 'sm');

  const [lastNotificationId, setLastNotificationId] = useState(null);

  const totalUnRead = notifications.filter((item) => item.isRead === false).length;

  const handleMarkAllAsRead = () => {
    notifications.forEach((notification) => {
      if (notification.isRead === false) {
        markNotificationAsRead(notification.id);
      }
    });
  };

  const handleClickItem = (path) => {
    drawer.onFalse();
    router.push(paths.dashboard.notification.root);
  };

  // useEffect(() => {
  //   const fetchNotifications = async () => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_HOST_API}/notifications-app/all/notifications/`, {
  //         headers: { Authorization: `Bearer ${sessionStorage.getItem('accessToken')}` },
  //       });
  //       const notification = response.data;
  //       const newNotification = notification.filter(n => n.id > (lastNotificationId || 0));
  //       newNotification.forEach(n => alert.info(n.message));
  //       if (notification.length > 0) {
  //         setLastNotificationId(notification[0].id);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching notifications:', error);
  //     }
  //   };

  //   fetchNotifications();
  //   const interval = setInterval(fetchNotifications, 10000);
  //   return () => clearInterval(interval);
  // }, [lastNotificationId]);

  const renderHead = (
    <Stack direction="row" alignItems="center" sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}>
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Notifications
      </Typography>

      {/* {!!totalUnRead && (
        <Tooltip title="Mark all as read">
          <IconButton color="primary" onClick={handleMarkAllAsRead}>
            <Iconify icon="eva:done-all-fill" />
          </IconButton>
        </Tooltip>
      )} */}

      {!smUp && (
        <IconButton onClick={drawer.onFalse}>
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      )}
    </Stack>
  );

  const renderList = (
    <Scrollbar>
      <List disablePadding>
        {/* Sort notifications by createdAt in descending order */}
        {[...notifications]
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          // eslint-disable-next-line arrow-body-style
          .map((notification) => {
            return (
        <NotificationItem
          key={notification.id}
          notification={{
            id: notification.id,
            title: notification.message,
            description: notification.sender,
            sender: notification.sender,
            createdAt: notification.createdAt,
            isUnRead: !notification.isRead,
            type: notification.type,
            text: notification.text
          }}
        />
        );
          })}
      </List>
    </Scrollbar>
  );

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        color={drawer.value ? 'primary' : 'default'}
        onClick={drawer.onTrue}
      >
        <Badge badgeContent={totalUnRead} color="error">
          <Iconify icon="solar:bell-bing-bold-duotone" width={24} />
        </Badge>
      </IconButton>

      <Drawer
        open={drawer.value}
        onClose={drawer.onFalse}
        anchor="right"
        slotProps={{
          backdrop: { invisible: true },
        }}
        PaperProps={{
          sx: { width: 1, maxWidth: 420 },
        }}
      >
        {renderHead}

        <Divider />

        {renderList}

        <Box sx={{ p: 1 }}>
          <Button fullWidth
            size="large"
            onClick={() => handleClickItem()}
          >
            View All
          </Button>
        </Box>
      </Drawer>
    </>
  );
}